import * as moment from 'moment';
import { Moment } from 'moment';
import { MailType } from './mail-type';
import { sample, uniqueId } from 'lodash-es';

export interface IMail {
  _id?: string;
  user_id?: string;
  type?: MailType;
  from?: string;
  date?: string | Moment;
  is_read?: boolean;
  is_open?: boolean;
  important?: boolean;
  theme?: string;
  message?: string;
}

export class Mail implements IMail {
  _id: string;
  user_id: string;
  is_open: boolean;
  type: MailType;
  from: string;
  date: Moment;
  is_read: boolean;
  theme: string;
  message: string;
  important: boolean;

  constructor( data: IMail = {} ) {
    this._id = data._id;
    this.is_open = false;
    this.user_id = data.user_id;
    this.type = data.type;
    this.from = data.from;
    this.date = data.date ? moment(data.date) : null;
    this.is_read = data.is_read;
    this.theme = data.theme;
    this.message = data.message;
    this.important = data.important || false;
  }

}


// WEBPACK FOOTER //
// ./app/states/mailbox/shared/mail.ts